import React from 'react';
import { motion } from 'framer-motion';
export function Hero() {
  return <section className="relative pt-20 pb-16 md:pt-32 md:pb-24 px-4 sm:px-6 lg:px-8 overflow-hidden" data-id="element-88">
      <div className="max-w-5xl mx-auto" data-id="element-89">
        <div className="flex flex-col md:flex-row gap-12 items-center" data-id="element-90">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.6
        }} className="flex-1 text-left" data-id="element-91">
            <span className="inline-block py-1 px-3 rounded-full bg-amber-100 text-amber-800 text-sm font-semibold mb-6" data-id="element-92">
              Guía práctica en español
            </span>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-stone-900 leading-tight mb-6 tracking-tight" data-id="element-93">
              No te falta IA. <br data-id="element-94" />
              <span className="text-amber-700" data-id="element-95">
                Te falta una forma de pedir.
              </span>
            </h1>

            <p className="text-xl md:text-2xl text-stone-600 mb-8 font-medium" data-id="element-96">
              En 48 horas: 10 prompts listos para tu negocio (sin tecnicismos).
            </p>

            <div className="prose prose-lg text-stone-600 mb-10 leading-relaxed" data-id="element-97">
              <p data-id="element-98">
                Hay un momento que casi nadie admite. Abres ChatGPT con la
                urgencia encima —un cliente esperando respuesta, una oferta por
                escribir, un post que "deberías" publicar— y te quedas mirando
                la pantalla como si te estuviera evaluando.
              </p>
              <p className="mt-4" data-id="element-99">
                Escribes algo rápido… y te devuelve un texto correcto, pero
                vacío. Genérico. Robótico. Como si no conociera tu negocio
                (porque no lo conoce). Y ahí llega la idea venenosa: "Tal vez yo
                no sirvo para esto."
              </p>
              <p className="mt-4 font-semibold text-stone-800" data-id="element-100">
                No. Lo que pasa es más simple y más frustrante: nadie te enseñó
                a pedir.
              </p>
            </div>

            <div className="flex items-center gap-3 mb-4" data-id="element-101">
              <span className="text-2xl text-stone-400 line-through font-medium" data-id="element-102">
                $25.00
              </span>
              <span className="text-4xl font-bold text-amber-700" data-id="element-103">$6.36</span>
              <span className="bg-red-100 text-red-700 text-sm font-bold px-2 py-1 rounded-full" data-id="element-104">
                -75%
              </span>
            </div>

            <button onClick={() => document.getElementById('comprar')?.scrollIntoView({
            behavior: 'smooth'
          })} className="inline-flex items-center justify-center rounded-full font-bold text-lg bg-amber-600 text-white hover:bg-amber-700 shadow-lg shadow-amber-900/10 h-14 px-8 w-full sm:w-auto transition-colors" data-id="element-105">
              Quiero mi guía (PDF)
            </button>
            <p className="mt-4 text-sm text-stone-500" data-id="element-106">
              Descarga inmediata • Acceso de por vida
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="flex-1 w-full max-w-md md:max-w-none" data-id="element-107">
            <div className="relative" data-id="element-108">
              <div className="absolute inset-0 bg-amber-200 rounded-3xl rotate-3 transform scale-95 opacity-50 blur-xl" data-id="element-109"></div>
              <img src="https://cdn.magicpatterns.com/uploads/gCQhwT6kfqdTgBKuKtYsY2/IMAGEN_AI_48.png" alt="IA Sin Miedo en un teléfono móvil" className="relative rounded-3xl shadow-2xl border-4 border-white w-full h-auto object-cover" data-id="element-110" />
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}